import { useMutation, useQueryClient } from '@tanstack/react-query';
import { CrewMerchantUi } from 'corso-types';
import api from '~/api';
import {
  shippingClaimQueryKey,
  useShippingClaim,
} from '~/features/shippingClaimReview/ShippingClaimReviewProvider';
import { useStoreId } from '~/providers/StoreUserProvider';

export function useShippingClaimUpdateCustomerInfo() {
  const storeId = useStoreId();
  const shippingClaim = useShippingClaim();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: CrewMerchantUi.ShippingClaimUpdateCustomerInfo) =>
      api
        .store(storeId)
        .shippingProtection.claim(`${shippingClaim.id}`)
        .updateCustomerInfo(body),
    onSettled: () =>
      queryClient.invalidateQueries({
        queryKey: shippingClaimQueryKey(shippingClaim.id, storeId),
      }),
  });
}
